var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M20.3086 5.28491H13.2224V3.31543H10.7877V5.28491H3.69165V8.31337H5.19598L5.77 21.6148H18.2401L18.8141 8.31337H20.3185V5.28491H20.3086ZM10.6888 19.2H8.70938V10.0948H10.6888V19.2ZM15.2908 19.2H13.3114V10.0948H15.2908V19.2Z",
    fill: "#B52020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminate);
export default __webpack_public_path__ + "static/media/terminate.83c482971b8be1c24d6c0e00d7b1723f.svg";
export { ForwardRef as ReactComponent };